import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { whyPoints } from '../mock';
import useReveal from '../hooks/useReveal';

function Card({ p, index }) {
  const { ref, inView } = useReveal();
  return (
    <div ref={ref} style={{ animationDelay: `${index * 90}ms` }} className={`reveal ${inView ? 'in-view' : ''} bg-white rounded-2xl border border-slate-100 shadow-sm p-6 card-hover`}>
      <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
        <CheckCircle2 className="w-6 h-6 text-primary" />
      </div>
      <h3 className="text-lg font-bold text-slate-900 font-display">{p.title}</h3>
      <p className="mt-2 text-sm text-slate-600">{p.desc}</p>
    </div>
  );
}

export default function WhyUs() {
  return (
    <section id="why" className="py-20 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-primary font-semibold uppercase tracking-wider text-sm">Why Lockene</span>
          <h2 className="mt-2 text-3xl lg:text-4xl font-extrabold text-slate-900 font-display">
            Why Certification Matters for Your Business
          </h2>
          <p className="mt-3 text-slate-600">
            Proper certification ensures your products meet strict safety, quality and reliability standards&mdash;protecting consumers and strengthening your brand across India.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyPoints.map((p, i) => (
            <Card key={p.title} p={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
